export const TARGETS = {
  POST_NOTIFICATIONS: 'postNotifications',
  IMPORT_NOTIFICATIONS: 'importNotifications',
  PUT_NOTIFICATION: 'putNotification',
  CONFIGURATE_FILE_NOTIFICATIONS: 'configurateFileNotifications',
  UPDATE_PARTICULAR_CONFIG: 'updateParticularConfig',
  DELETE_PARTICULAR_CONFIG: 'deleteParticularConfig'
};
